export default class Config {
  public static isDev() {
    const { MODE } = import.meta.env;
    // `docker` is the local/CI stack mode (`pnpm docker`), never a deployed environment,
    // so dev-only conveniences (verbose logging, flag overrides) apply there too.
    return MODE === 'development' || MODE === 'docker';
  }

  public static getReleaseVersion() {
    return import.meta.env.VITE_RELEASE_VERSION || 'Not set';
  }

  public static isProd() {
    const { MODE } = import.meta.env;
    return MODE === 'production';
  }

  public static isStaging() {
    const { MODE } = import.meta.env;
    return MODE === 'staging';
  }

  public static getAuthBasePath() {
    return import.meta.env.VITE_ORY_TUNNEL_URL || 'http://localhost:4000';
  }

  public static getApiUrl() {
    return import.meta.env.VITE_API_URL || 'http://localhost:8000';
  }
}
